export default function LocalStorageAlternative () {

  const localStorageAlternative = {}

  this.setItem = function ( key, value ) {
    localStorageAlternative[key] = value
  }

  this.getItem = function ( key ) {
    if( typeof localStorageAlternative[key] !== 'undefined' ) {
      return localStorageAlternative[key]
    }
    else {
      return null
    }
  }

  this.removeItem = function ( key ) {
    localStorageAlternative[key] = undefined
  }
}


// WEBPACK FOOTER //
// ./src/storage/alternative.storage.js